import { resolveImageUrl, DEFAULT_CARD_BG, DEFAULT_CARD_ICON, withCacheBust } from './imageDefaults';
import { resolveTemplateColors } from './templateColors';
import { normalizePatternId } from './cardPatterns';

function readTemplate(card) {
  const raw = card?.template;
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  return {};
}

function readUser(card) {
  return card?.user && typeof card.user === 'object' ? card.user : {};
}

function templateVisuals(template = {}) {
  const colors = resolveTemplateColors(template);
  return {
    ...colors,
    cardStyle: template.cardStyle || 'plastic',
    backgroundPattern: normalizePatternId(template.backgroundPattern),
    gradientColor: template.gradientColor || null,
    gradientAngle: template.gradientAngle ?? 135,
  };
}

/** @param {'list' | 'detail'} context */
export function getCardStyle(card, { context = 'list' } = {}) {
  const template = readTemplate(card);
  const user = readUser(card);
  const visuals = templateVisuals(template);

  const base = {
    ...visuals,
    backText: template.backText || user.backText || '',
    templateName: template.name || '',
    cashback: template.cashback ?? 0,
    referralEnabled: !!user.referralEnabled,
    referralCode: user.referralEnabled ? (card?.referralCode || '') : '',
  };

  if (context === 'detail') {
    return {
      ...base,
      imageUrl: null,
      hasPhoto: false,
      iconUrl: null,
    };
  }

  const storeBg = user.backgroundUrl ? withCacheBust(resolveImageUrl(user.backgroundUrl, null)) : null;
  return {
    ...base,
    imageUrl: storeBg || DEFAULT_CARD_BG,
    hasPhoto: !!storeBg && !storeBg.includes('/def/'),
    iconUrl: withCacheBust(resolveImageUrl(user.logoUrl, DEFAULT_CARD_ICON)),
  };
}

export function getTemplatePreviewStyle(template = {}) {
  return {
    ...templateVisuals(template),
    cashback: template.cashback ?? 0,
    name: template.name || 'Уровень',
  };
}
